import { AfterViewInit, Component, ElementRef, EventEmitter, HostListener, Input, Output, ViewChild } from '@angular/core';
import SignaturePad from 'signature_pad';

@Component({
  selector: 'signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.scss']
})
export class SignaturePadComponent implements AfterViewInit {
  private signaturePad: SignaturePad;
  @Input() signatureNeeded: boolean = false;
  @Output() change = new EventEmitter<string>();
  @ViewChild('canvas') canvasEl!: ElementRef;
  private ctx: CanvasRenderingContext2D;

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.adjustCanvasSize();
  }

  private adjustCanvasSize() {
    const canvas = this.canvasEl.nativeElement;
    const imageData = this.ctx.getImageData(0, 0, canvas.width, canvas.height);
    canvas.width = canvas.parentElement!.clientWidth;
    canvas.height = canvas.parentElement!.clientHeight;
    this.ctx.putImageData(imageData, 0, 0);
  }

  ngAfterViewInit() {
    this.signaturePad = new SignaturePad(this.canvasEl.nativeElement);
    this.ctx = this.canvasEl.nativeElement.getContext('2d');
    this.adjustCanvasSize();
  }

  endDrawing(event: Event) {
    let base64Data = this.signaturePad.toDataURL();
    base64Data = base64Data.replace(/^data:image\/png;base64,/, '');
    this.change.emit(base64Data);
  }

  clearPad() {
    this.signaturePad.clear();
    this.change.emit('');
  }
}